<template>
  <span>
    <!-- filters -->
    <v-row>
      <v-col>
        <v-card elevation="5">
          <v-card-text>
            <v-row dense align="center">
              <v-col cols="2">
                <v-text-field
                  label="Case Name"
                  v-model="caseName"
                  dense
                  clearable
                />
              </v-col>
              <v-col cols="3">
                <v-select
                  dense
                  label="Screened By"
                  v-model="screenedBy"
                  :items="users"
                  item-value="email"
                  :item-text="
                    (item) => {
                      return getTextForUserSelect(item);
                    }
                  "
                  clearable
                />
              </v-col>
              <v-col cols="3">
                <v-select
                  v-model="assignedTo"
                  :items="users"
                  item-value="email"
                  :item-text="
                    (item) => {
                      return getTextForUserSelect(item);
                    }
                  "
                  label="Assignee"
                  clearable
                  dense
                />
              </v-col>
              <v-col cols="2">
                <v-select
                  dense
                  label="Status"
                  v-model="status"
                  :items="reportStatusesFilterView"
                  item-text="title"
                  item-value="code"
                  clearable
                />
              </v-col>
              <!-- screened on -->
              <v-col cols="3">
                <v-menu
                  ref="screeningDateRange"
                  v-model="screeningDateRange"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateRangeFormattedComputed"
                      label="Screening Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                      clearable
                      @click:clear="clearScreeningDates"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="dates" range no-title>
                    <v-spacer />
                    <v-btn
                      text
                      color="primary"
                      @click="screeningDateRange = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.screeningDateRange.save(dates)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>

              <v-spacer />
              <v-col align="right" cols="1">
                <v-btn fab dark x-small color="blue" @click="search()">
                  <v-icon dark>mdi-magnify</v-icon>
                </v-btn>
                <!-- TODO put in refresh button -->
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- table -->
    <v-row dense>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="caseReports"
          :options.sync="options"
          :server-items-length="totalCaseReports"
          :footer-props="footerProps"
          disable-sort
          v-model="selected"
          item-key="id"
          :loading="loading || tableLoading"
          show-select
          no-data-text="All cases resolved"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-spacer />
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" dark v-bind="attrs" v-on="on">
                    Actions
                    <v-icon dark right> mdi-chevron-down </v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item
                    link
                    @click="onMultiAssignClick()"
                    :disabled="selected.length < 1"
                  >
                    <v-list-item-icon>
                      <v-icon> mdi-account-switch </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Assign Selected</v-list-item-title>
                      <v-list-item-subtitle
                        >Assign selected cases.</v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item
                    link
                    @click="onMultiResolveClick()"
                    :disabled="selected.length < 1"
                  >
                    <v-list-item-icon>
                      <v-icon> mdi-check </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{
                        $t("table.caseReport.actions.updateStatus.title")
                      }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                        $t("table.caseReport.actions.updateStatus.subTitle")
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item link @click="onCsvExport()">
                    <v-list-item-icon>
                      <v-icon> mdi-download </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Export History</v-list-item-title>
                      <v-list-item-subtitle
                        >Export CSV based on current search
                        parameters</v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-toolbar>
          </template>

          <template v-slot:item.matches="{ item }">
            <v-chip
              small
              outlined
              v-if="item.matches.length > 0"
              class="ma-2"
              color="red"
              text-color="red"
              >{{ item.matches.length }}</v-chip
            >
            <v-chip
              small
              outlined
              v-else
              class="ma-2"
              color="green"
              text-color="green"
              >0</v-chip
            >
          </template>

          <template v-slot:item.status="{ item }">
            <ResolutionStatusChips :resolutionStatus="item.status" />
          </template>

          <template v-slot:item.searchDate="{ item }">
            {{ formatDateTime(item.searchDate) }}
          </template>

          <template v-slot:item.controls="{ item }">
            <v-btn icon x-small color="blue" @click="onViewClick(item)">
              <v-icon dark>mdi-export</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </span>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { formatDateTime, dateRangeFormatted } from "../utils/dateUtils";
import { getTextForUserSelect } from "../utils/userUtils";
import ResolutionStatusChips from "../components/ResolutionStatusChips";
import { reportStatusesFilterView } from "../utils/reportStatuses";

export default {
  name: "CaseReportTable",
  components: { ResolutionStatusChips },
  data() {
    return {
      buttonLoading: false,
      loading: true,

      options: {},
      footerProps: { "items-per-page-options": [10, 20, 100, 200] },

      // search
      caseName: "",
      status: "U",
      screenedBy: null,
      assignedTo: this.$store.getters["getPreferences"].filters.resolution.assignedTo === undefined ? this.$store.getters["getProfile"].user.email : this.$store.getters["getPreferences"].filters.resolution.assignedTo,
      reportStatusesFilterView,
      screeningDateRange: false,
      dates: [],
      selected: [],

      headers: [
        { text: "Case", value: "searchCase.name" },
        { text: "Report Date", value: "searchDate" },
        { text: "Screened By", value: "screenedByUserName" },
        { text: "Assignee", value: "assignedToUserName" },
        { text: "Status", value: "status" },
        { text: "View", value: "controls", sortable: false, align: "right" }
      ]

    };
  },
  props: {
    tableLoading: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    options: {
      handler() {
        this.getCaseReports(true);
      },
      deep: true,
    },
  },

  computed: {
    ...mapGetters(["users", "caseReports", "getPreferences"]),
    totalCaseReports() {
      return this.$store.getters.totalCaseReports;
    },
    dateRangeFormattedComputed: {
      get: function () {
        return this.dateRangeFormatted(this.dates[0], this.dates[1]);
      },
      set: function (newDates) {
        newDates;
        //this.dates = [newDates];
      },
    },
  },

  methods: {
    ...mapActions(["getUsers", "fetchCaseReports", "setGlobalAlert", "setResolutionFilter"]),
    ...mapMutations(['clearCaseReports']),
    getTextForUserSelect,
    formatDateTime,
    dateRangeFormatted,
    onViewClick(caseReport) {
      this.$emit("onViewCaseReport", caseReport);
    },
    onMultiResolveClick() {
      this.$emit("onMultiResolveClick", this.selected);
      //this.selected = [];
    },
    onMultiAssignClick() {
      this.$emit("onMultiAssignClick", this.selected);
      //this.selected = [];
    },
    getCaseReports(pagination) {
      this.loading = true;

      var request = { ...this.options };
      request.pagination = pagination;
      //request.page = request.page - 1; // Vuetify is 1 indexed, Mongo drvier is 0 indexed

      if (this.screenedBy) request.screenedBy = this.screenedBy;
      if (this.assignedTo) request.assignedTo = this.assignedTo;
      if (this.caseName) request.caseName = this.caseName;
      if (this.dates[0]) request.screenedAfter = this.dates[0];
      if (this.dates[1]) request.screenedBefore = this.dates[1];
      if (this.status) {
        request.status = [this.status];
      }

      this.fetchCaseReports(request)
        .catch(() => {
          this.setGlobalAlert({
            alert: true,
            color: "red",
            alertTitle: "There's been a problem.",
            alertMessage: "Unable to retreive history, please try again later.",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    search() {
      this.setResolutionFilter({assignedTo: this.assignedTo})
      this.getCaseReports(true);
    },
    clearScreeningDates() {
      this.dates = [];
    },
    onCsvExport() {

      if(this.$store.getters.totalCaseReports > 10000){
        this.setGlobalAlert({
          alert: true,
          color: "black",
          alertTitle: "Please narrow your search.",
          alertMessage: "You're attempting to export " + this.$store.getters.totalCaseReports + " rows, but CSV exports must be 10,000 rows or less. Please narrow your search and try again.",
        });
        return;
      }

      var request = {};
      if (this.screenedBy) request.screenedByUserName = this.screenedBy;
      if (this.assignedTo) request.assignedToUserName = this.assignedTo;
      if (this.caseName) request.caseName = this.caseName;
      if (this.dates[0]) request.screenedAfter = this.dates[0];
      if (this.dates[1]) request.screenedBefore = this.dates[1];
      if (this.status) {
        request.status = [this.status];
      }

      let routeData = this.$router.resolve({
        name: "caseReportCsv",
        query: request,
      });
      const link = document.createElement("a");
      link.href = routeData.href;
      link.click();
    },
  },

  created() {
    this.clearCaseReports();
    this.getUsers()
      .catch(() => {
        this.setGlobalAlert({
          alert: true,
          color: "red",
          alertTitle: "There's been a problem.",
          alertMessage: "Unable to retreive users, support has been notified.",
        });
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>